import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Galleria } from 'primereact/galleria'
import { Photo } from '../../models/media'
import LuxButton from '../buttons/Button'
import './media.scss'

const LightboxGallery = (props: {
    _ref: any
    photos: Photo[]
    activeIndex: number
    setActiveIndex: (newIndex: number) => void
    showThumbnails?: boolean
}) => {
    const { _ref, photos, activeIndex, setActiveIndex, showThumbnails } = props

    const onEsc = useCallback((event: any) => {
        if (event.keyCode === 27) {
            _ref.current.hide()
        }
    }, [])

    useEffect(() => {
        document.addEventListener('keydown', onEsc, false)

        return () => {
            document.removeEventListener('keydown', onEsc, false)
        }
    }, [])

    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 5,
        },
        {
            breakpoint: '768px',
            numVisible: 3,
        },
        {
            breakpoint: '560px',
            numVisible: 1,
        },
    ]

    const onItemChange = (event: any) => {
        setActiveIndex(event.index)
    }

    const downloadPhoto = async (photo: Photo) => {
        const response = await fetch(photo.thumbnail_fullpath)
        const photo_name = photo.fileName
            ? photo.fileName
            : photo.name
            ? photo.name + '.jpg'
            : 'luxottica.jpg'
        if (response.status === 200) {
            const blob = await response.blob()
            const url = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = photo_name
            document.body.appendChild(link)
            link.click()
            link.remove()
            return { success: true }
        } else {
            alert('Oops! Something went wrong.')
        }
    }

    const itemTemplate = (photo: Photo) => {
        return (
            <>
                <img
                    alt={photo.alt}
                    src={photo.thumbnail_fullpath}
                    className="p-galleria-item-image"
                />
                <div className="p-galleria-item-content">
                    <div>{photo.description}</div>
                    <div>
                        {photos.indexOf(photo) + 1}/{photos.length}
                    </div>
                    <div>
                        <LuxButton
                            text={''}
                            icon={'download'}
                            variant={['primary']}
                            onClick={() => downloadPhoto(photo)}
                        />
                    </div>
                </div>
            </>
        )
    }

    const thumbnailTemplate = (photo: Photo) => {
        return (
            <img
                alt={photo.alt}
                src={photo.thumbnail_fullpath}
                style={{ display: 'block' }}
            />
        )
    }

    return (
        <Galleria
            ref={_ref}
            value={photos}
            activeIndex={activeIndex}
            className={'luxLightboxGallery'}
            responsiveOptions={responsiveOptions}
            circular
            fullScreen
            numVisible={9}
            showItemNavigators
            item={itemTemplate}
            style={{ maxWidth: '50%' }}
            onItemChange={onItemChange}
            thumbnail={thumbnailTemplate}
            showThumbnails={showThumbnails ? showThumbnails : false}
        />
    )
}

export default LightboxGallery
